import Datetime from "./Datetime.vue";

const DatetimePlugin = {
  install(Vue) {
    Vue.component("datetime", Datetime);
  }
};

// Install by default if using the script tag
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(DatetimePlugin);
}

export default DatetimePlugin;

// Export all components too
export { Datetime };
